import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { Flex, Button } from '@simplybusiness/mobius-simplybusiness';

import Text from '../atoms/Text';
import Label from '../atoms/Label';

const ErnAvailableQuestion = () => {
  const { register, setValue, watch } = useFormContext();

  const { customerHaveErn } = watch();

  useEffect(() => {
    register({ name: 'customerHaveErn' });
  }, [register]);

  const yesButtonVariant = customerHaveErn ? 'secondary' : 'ghost';
  const noButtonVariant = customerHaveErn ? 'ghost' : 'secondary';

  return (
    <Flex flexDirection="column" marginBottom="size-50">
      <Label paddingBottom="size-30">
        Do you have an Employer PAYE Reference Number (ERN)?
      </Label>
      <Text paddingBottom="size-30">
        Because you have chosen employers' liability cover we need to know your
        Employer PAYE Reference Number (ERN) or know that you are exempt.
      </Text>
      <Text paddingBottom="size-50">
        We'll update The Employers' Liability Tracing Office (ELTO) database
        so it's easy to prove you're insured if an employee makes a claim against you.
      </Text>

      <Flex>
        <Button
          onPress={() => setValue('customerHaveErn', true)}
          variant={yesButtonVariant}
          width={102}
          height={38}
          marginRight="size-30"
        >
          Yes
        </Button>
        <Button
          onPress={() => setValue('customerHaveErn', false)}
          variant={noButtonVariant}
          width={102}
          height={38}
        >
          No
        </Button>
      </Flex>
    </Flex>
  );
};

export default ErnAvailableQuestion;
